module.exports = __webpack_public_path__ + "img/code.ff9af11e.png";